package org.gstechnovos.jexonplastech.pages

import ServiceSection
import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.gstechnovos.jexonplastech.components.BackToTopButton
import org.gstechnovos.jexonplastech.components.ExperienceSection
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.sections.*
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint

@OptIn(DelicateApi::class)
@Page
@Composable
fun HomePage() {

    val breakpoint = rememberBreakpoint()
    var menuOpen by remember { mutableStateOf(false) }

    CompositionLocalProvider(LocalBreakpoint provides breakpoint) {
        Box(
            modifier = Modifier.fillMaxSize()
        ) {
            Column(
                modifier = Modifier.fillMaxSize().backgroundColor(Theme.LighterGray.rgb),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                MainSection(
                    onMenuClick = {
                        menuOpen = true
                    })
                AboutUsSection()
                ServiceSection()
                PortfolioSection()
                AchievementsSection()
                TestimonialSection()
                ExperienceSection()
                ContactMeSection()
                FooterSection()
            }

            BackToTopButton()

            if (menuOpen) {
                OverFlowMenu(
                    onMenuClosed = { menuOpen = false })
            }
        }
    }
}
